export const filterByTeam = (events, teams) =>
    events.filter((event) => {
        return event.references.find((ref) =>
            teams.includes(parseInt(ref.reference))
        );
    });
